<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Shop Left Sidebar" mainTitle="Shop Left Sidebar" />
  <ShopLeftSidebar />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import ShopLeftSidebar from "../components/ShopLeftSidebar/ShopLeftSidebar.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ShopLeftSidebarPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    ShopLeftSidebar,
    DownloadTheApp,
    MainFooter,
  },
});
</script>